const initialState = {
    sidebarOpen: false,
    notifications: [],
    error: {},
    newTrackModalVisible: false,
    feedbackModalVisible: false,
    offlineModalVisible: false,
    iOSModalVisible: false,
    userInputtingText: false,
    dismissedOfflineNotification: false,
    wasmMemoryUsage:0,
    clientConfig: null,
    showLyrics: false,
    soloMode: false,
    showDeveloperTools: false,
    parentVersion: null,
    appStarted: false
  };

export default initialState;